import { getClientLabel, getClientLabelCapitalized } from '@/lib/form-state/util'
import { useAuth } from '@/store/hooks'

export function useClientLabel() {
    const { user } = useAuth()
    const segment = user?.company?.segment
    const secondarySegment = user?.company?.secondarySegment

    return {
        clientLabel: getClientLabel(segment, secondarySegment),
        ClientLabel: getClientLabelCapitalized(segment, secondarySegment),
    }
}
